import script from "./SectionContact.vue?vue&type=script&setup=true&lang=ts"
export * from "./SectionContact.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__